var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-view hotspot"},[_c('div',{staticClass:"quest"},[_c('div',{staticClass:"title"},[_c('vue-mathjax',{attrs:{"formula":_vm.form.title,"safe":false},on:{"onRenderComplete":_vm.mathjaxRes}})],1)]),_c('div',{staticClass:"quest-img"},[_c('img',{attrs:{"src":_vm.form.img_url,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }